import React from "react";
import { message } from "antd";
import { Drawer } from "antd";
import { Tabs } from "antd";
import { Form, Button, Icon } from "antd";

import LayoutDefault from "../../shared/LayoutDefault";

import UserTable from "./UserTable";
import UserForm from "./UserForm";
import UserPasswordForm from "./UserPasswordForm";

class UserView extends React.Component {
  static defaultProps = {
    onCreate: async (row) => {},
    onUpdate: async (row) => {},
    onDelete: async (row) => {},
  };

  state = {
    loading: false,
    edit: undefined,
    create: undefined,
  };

  handleCreateRequested = () => {
    this.setState({ create: new Date() });
  };

  handleCreateCancelled = () => {
    this.setState({ create: undefined });
  };

  handleCreateSubmitted = async (values) => {
    this.setState({ loading: true });
    const errors = await this.props.onCreate(values);
    this.setState({ loading: false });
    if (errors) {
      return errors;
    }
    this.setState({ create: undefined });
    message.success("The user has been created");
  };

  handleEditRequested = (row) => {
    this.setState({ edit: row });
  };

  handleEditCancelled = () => {
    this.setState({ edit: undefined });
  };

  handleEditSubmitted = async (values) => {
    const {
      edit: { id },
    } = this.state;
    this.setState({ loading: true });
    const errors = await this.props.onUpdate({ ...values, id });
    this.setState({ loading: false });
    if (errors) {
      return errors;
    }
    message.success("The user has been updated");
  };

  handleEditPasswordSubmitted = async (values) => {
    const {
      edit: { id },
    } = this.state;
    this.setState({ loading: true });
    const errors = await this.props.onUpdatePassword({ ...values, id });
    this.setState({ loading: false });
    if (errors) {
      return errors;
    }
    message.success("The user's password has been updated");
  };

  handleDeleteConfirmed = async (row) => {
    this.setState({ loading: true });
    await this.props.onDelete(row);
    message.success("The user has been deleted");
    this.setState({ loading: false });
  };

  render() {
    const {
      data: { userSet, licenseSet, loading: dataLoading },
    } = this.props;

    const { create, edit, loading } = this.state;

    return (
      <LayoutDefault>
        {!dataLoading && (
          <React.Fragment>
            <Form.Item>
              <Button
                size="small"
                onClick={this.handleCreateRequested}
                loading={loading}
              >
                <Icon type="user-add" />
                Create a user
              </Button>
            </Form.Item>

            <UserTable
              userSet={userSet}
              licenseSet={licenseSet}
              loading={loading}
              onEdit={this.handleEditRequested}
              onDelete={this.handleDeleteConfirmed}
            />

            <Drawer
              visible={!!create}
              title="Create user"
              onClose={this.handleCreateCancelled}
              width="60%"
            >
              <UserForm
                key={create}
                row={{}}
                licenseSet={licenseSet}
                loading={loading}
                onSubmit={this.handleCreateSubmitted}
              />
            </Drawer>

            <Drawer
              visible={!!edit}
              title={edit && `Edit ${edit.username}`}
              onClose={this.handleEditCancelled}
              width="60%"
            >
              {edit && (
                <Tabs>
                  <Tabs.TabPane tab="Data" key="data">
                    <UserForm
                      row={edit}
                      licenseSet={licenseSet}
                      loading={loading}
                      onSubmit={this.handleEditSubmitted}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Password" key="password">
                    <UserPasswordForm
                      row={edit}
                      loading={loading}
                      onSubmit={this.handleEditPasswordSubmitted}
                    />
                  </Tabs.TabPane>
                </Tabs>
              )}
            </Drawer>
          </React.Fragment>
        )}
      </LayoutDefault>
    );
  }
}

export default UserView;
